import { normalizeUrl } from '@atlaskit/linking-common/url';

type SourceWithUrl = {
	url?: string | null;
};

export const normalizeSourceUrlForComparison = (url: string | null | undefined): string => {
	const normalizedUrl = normalizeUrl(url);

	if (!normalizedUrl) {
		return '';
	}

	try {
		const parsedUrl = new URL(normalizedUrl);

		parsedUrl.protocol = parsedUrl.protocol.toLowerCase();
		parsedUrl.hostname = parsedUrl.hostname.toLowerCase();
		parsedUrl.hash = '';

		if (
			(parsedUrl.protocol === 'https:' && parsedUrl.port === '443') ||
			(parsedUrl.protocol === 'http:' && parsedUrl.port === '80')
		) {
			parsedUrl.port = '';
		}

		parsedUrl.pathname = parsedUrl.pathname.replace(/\/+$/, '') || '/';

		return parsedUrl.toString();
	} catch {
		return normalizedUrl.trim().replace(/\/+$/, '');
	}
};

export const isDuplicateSourceUrl = (url: string, sources: readonly SourceWithUrl[]): boolean => {
	const sourceUrl = normalizeSourceUrlForComparison(url);

	return Boolean(
		sourceUrl &&
		sources.some((source) => normalizeSourceUrlForComparison(source.url) === sourceUrl),
	);
};
